import * as Constants from '../constants/UserConstants';

export const setUserData = (payload:any) => {
    return {
        type:Constants.SET_USER_DATA,
        data:payload
    }
}

export const clearUserData = (payload:any) => {
    return {
        type:Constants.CLEAR_USER_DATA,
        data:payload
    }
}